import { render, staticRenderFns } from "./ViewBox.vue?vue&type=template&id=64fac264"
import script from "./ViewBox.vue?vue&type=script&lang=js"
export * from "./ViewBox.vue?vue&type=script&lang=js"
import style0 from "./ViewBox.vue?vue&type=style&index=0&id=64fac264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports